import * as React from 'react';

import { Blurb } from '../Contentful/Blurb';
import { useReseller } from 'hooks/Reseller/useReseller';

export const TermsAndConditions: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  const { contentfulReseller } = useReseller();

  if (!contentfulReseller) return null;

  return (
    <div className={className} {...props}>
      <Blurb entry={contentfulReseller} field="legalDisclosureFooterBlurb" />
    </div>
  );
};
